export default {
    GET_COMPANY_CONFIGS: () => '/companyConfig',
};
